import { render, staticRenderFns } from "./EditorGroupEditorTableDetails.vue?vue&type=template&id=46072fba&"
import script from "./EditorGroupEditorTableDetails.vue?vue&type=script&lang=js&"
export * from "./EditorGroupEditorTableDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports